import React from 'react';
import { Stack, type SxProps, type Theme, Typography } from '@mui/material';
import clsx from 'clsx';
import { mergeSx } from 'merge-sx';

import { FolderType } from '@/api/generated';
import HierarchyFolderIcon from '@/assets/icons/hierarchy-inline-folder.svg?react';
import HierarchyOrgIcon from '@/assets/icons/hierarchy-inline-org.svg?react';
import HierarchySubFolderIcon from '@/assets/icons/hierarchy-inline-subfolder.svg?react';
import HierarchySubOrgIcon from '@/assets/icons/hierarchy-inline-suborg.svg?react';

const LocationItem = ({
  type,
  name,
  className,
  role,
  sx
}: {
  type?: FolderType;
  name?: string;
  className?: string;
  role?: string;
  sx?: SxProps<Theme>;
}) => (
  <Stack
    direction="row"
    gap={1}
    alignItems="center"
    className={clsx('LocationItem-root', className, type === FolderType.ORGANIZATION && 'LocationItem-organization')}
    sx={mergeSx({}, sx)}
  >
    {type === FolderType.ORGANIZATION && <HierarchyOrgIcon className="LocationItem-icon" />}
    {type === FolderType.SUB_ORGANIZATION && <HierarchySubOrgIcon className="LocationItem-icon" />}
    {type === FolderType.SUB_FOLDER && <HierarchySubFolderIcon className="LocationItem-icon" />}
    {type === FolderType.FOLDER && <HierarchyFolderIcon className="LocationItem-icon" />}
    <Typography variant="body3" className="LocationItem-label" title={name}>
      {name}
    </Typography>
    {role && (
      <Typography
        className="LocationItem-role"
        variant="body3"
        bgcolor="grey.300"
        color="grey.900"
        borderRadius={100}
        sx={{ px: 0.5, my: 0.25 }}
        title={role}
      >
        {role}
      </Typography>
    )}
  </Stack>
);

export default LocationItem;
